import { HttpRequestData, httpUtil, PaginationResponse } from '@esg/framework';
import { getEnv, PaginationRequest } from '@esg/shared';

interface GetCustomersRequest extends HttpRequestData {
    readonly query: PaginationRequest & {
        startTime?: string;
        endTime?: string;
        branchId?: string;
    };
}

export interface CustomerItem {
    id: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
}


export interface CustomerItem {
    id: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phone: string | null;
    profileCreationTime: string;
    lastActivityTime: string;
    customerLabel: string | null;
}


export const getCustomers = httpUtil.createHttpRequestMeta<
    GetCustomersRequest,
    PaginationResponse<CustomerItem>
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/customers',
    method: 'GET',
    authentication: 'bearer',
});